export default {
  path: '/hotel-management',
  component: () => import('@/views/hotel-management/Index'),
  redirect: { name: 'hotel-management-transactions' },
  children: [
    {
      path: 'balance',
      name: 'hotel-management-balance',
      component: () => import('@/views/hotel-management/Balance'),
      meta: {
        title: 'Hotel management',
        roles: ['hotel_reception']
      }
    },
    {
      path: 'shop-stocktaking',
      name: 'hotel-management-shop-stocktaking',
      component: () => import('@/views/hotel-management/shop-stocktaking/ShopStocktaking'),
      meta: {
        title: 'Hotel management',
        roles: ['general_manager', 'hotel_reception']
      }
    },
    {
      path: 'shop-stocktaking/:id',
      name: 'hotel-management-shop-stocktaking-detail',
      component: () => import('@/views/hotel-management/shop-stocktaking/Detail'),
      meta: {
        title: 'Hotel management',
        roles: ['general_manager', 'hotel_reception']
      }
    },
    {
      path: 'supervising',
      component: () => import('@/views/hotel-management/supervising/Layout'),
      children: [
        {
          path: '',
          name: 'hotel-management-supervising',
          component: () => import('@/views/hotel-management/supervising/Reservations'),
          meta: {
            title: 'Hotel management',
            roles: ['general_manager']
          }
        },
        {
          path: 'house-accounts',
          name: 'hotel-management-supervising-house-accounts',
          component: () => import('@/views/hotel-management/supervising/HouseAccounts'),
          meta: {
            title: 'Hotel management',
            roles: ['general_manager']
          }
        }
      ]
    },
    {
      path: 'balance-history',
      component: () => import('@/views/hotel-management/balance-history/Index'),
      children: [
        {
          path: '',
          name: 'hotel-management-balance-history',
          component: () => import('@/views/hotel-management/balance-history/List'),
          meta: {
            title: 'Hotel management',
            roles: ['general_manager']
          }
        },
        {
          path: ':id',
          name: 'hotel-management-balance-history-detail',
          component: () => import('@/views/hotel-management/balance-history/Detail'),
          meta: {
            title: 'Hotel management',
            roles: ['general_manager']
          }
        }
      ]
    },
    {
      path: 'transactions',
      name: 'hotel-management-transactions',
      component: () => import('@/views/hotel-management/Transactions'),
      meta: {
        title: 'Hotel management',
        roles: ['general_manager', 'hotel_reception']
      }
    },
    {
      path: 'supervising/house-accounts/:id',
      name: 'hotel-management-supervising-house-accounts-detail',
      component: () => import('@/views/hotel-management/supervising/HouseAccountsDetail'),
      meta: {
        title: 'Hotel management',
        roles: ['general_manager']
      }
    },
    {
      path: 'supervising/:id',
      component: () => import('@/views/hotel-management/supervising/reservations-detail/Layout'),
      children: [
        {
          path: '',
          name: 'hotel-management-supervising-detail',
          component: () => import('@/views/hotel-management/supervising/reservations-detail/Transactions'),
          meta: {
            title: 'Hotel management',
            roles: ['general_manager']
          }
        },
        {
          path: 'accommodation',
          name: 'hotel-management-supervising-detail-accommodation',
          component: () => import('@/views/hotel-management/supervising/reservations-detail/Accommodation'),
          meta: {
            title: 'Hotel management',
            roles: ['general_manager']
          }
        },
      ]
    },
    {
      path: 'check-availability',
      name: 'hotel-management-check-availability',
      component: () => import('@/views/hotel-management/CheckAvailability'),
      meta: {
        title: 'Check availability',
        roles: ['general_manager']
      }
    },
    {
      path: 'invoices',
      component: () => import('@/views/hotel-management/invoices/Index'),
      children: [
        {
          path: '',
          name: 'hotel-management-invoices-list',
          component: () => import('@/views/hotel-management/invoices/List'),
          meta: {
            title: 'Invoices',
            roles: ['general_manager']
          }
        },
        {
          path: ':id',
          name: 'hotel-management-invoices-detail',
          component: () => import('@/views/hotel-management/invoices/Detail'),
          meta: {
            title: 'Invoices',
            roles: ['general_manager']
          }
        }
      ]
    },
  ]
}
